<template>
  <div class="constructionSchedule">
    <div class="progressPlan">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-size: 24px">协同工作进度计划</span>
          <div class="head-text" style="float: right; margin-top: -4px">
            <el-input
              placeholder="请输入任务名称关键词"
              class="search-input"
            ></el-input>
            <el-button
              slot="append"
              icon="el-icon-search"
              style="margin-r ight: 80px"
            ></el-button>
            <el-button
              type="primary"
              @click="PlanStartAudit"
              v-if="(zwpp12 == 0 || zwpp12 == 3) && ganttShow && zwpp11"
              >提交审核</el-button
            >
            <el-button
              v-if="
                ((zwpp12 == 0 || zwpp12 == 3) && ganttShow) ||
                (!zwpp11 && zwpp12 == 2)
              "
              type="primary"
              @click="updateDom(2)"
              >保存节点</el-button
            >
            <el-button
              v-if="
                ((zwpp12 == 0 || zwpp12 == 3) && ganttShow) ||
                (!zwpp11 && zwpp12 == 2)
              "
              type="primary"
              @click="deleteDom2"
              >删除当前行</el-button
            >
            <el-button
              v-if="
                ((zwpp12 == 0 || zwpp12 == 3) && ganttShow) ||
                (!zwpp11 && zwpp12 == 2)
              "
              type="primary"
              @click="addChildDom2"
              >插入节点</el-button
            >
            <el-button
              v-if="
                ((zwpp12 == 0 || zwpp12 == 3) && ganttShow) ||
                (!zwpp11 && zwpp12 == 2)
              "
              type="primary"
              @click="domUp"
              >上移</el-button
            >
            <el-button
              v-if="
                ((zwpp12 == 0 || zwpp12 == 3) && ganttShow) ||
                (!zwpp11 && zwpp12 == 2)
              "
              type="primary"
              @click="domDown"
              >下移</el-button
            >
            <el-button
              v-if="
                ((zwpp12 == 0 || zwpp12 == 3) && ganttShow) ||
                (!zwpp11 && zwpp12 == 2)
              "
              type="primary"
              @click="batchProject"
              >导入project</el-button
            >
            <el-button
              v-if="
                ((zwpp12 == 0 || zwpp12 == 3) && ganttShow) ||
                (!zwpp11 && zwpp12 == 2)
              "
              type="primary"
              @click="batchAddDom"
              >导入Excel</el-button
            >
            <!-- <el-button type="primary" @click="dialogVisibleOPen">节点管理</el-button> -->
            <el-button
              @click="ganttShow = !ganttShow"
              :type="ganttShow ? 'success' : 'danger'"
              >{{ ganttShow ? "甘特图" : "关闭甘特图" }}</el-button
            >
            <el-button v-if="ganttShow" @click="backRouter" type="info"
              >返回</el-button
            >
          </div>
        </div>
        <el-table
          v-if="ganttShow"
          v-loading="loading"
          :data="tableData"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          row-key="zwpd01"
          :highlight-current-row="true"
          default-expand-all
          :tree-props="{ children: 'children' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column width="100px" label="父子级">
            <template slot-scope="scope">
              <i
                v-if="scope.row.children.length > 0"
                class="el-icon-folder"
              ></i>
              <i v-else class="el-icon-tickets"></i>
            </template>
          </el-table-column>
          <el-table-column property="zwpd04" label="任务名称" width="200px">
            <template slot-scope="scope">
              <el-input
                :disabled="isDisabled"
                v-model="scope.row.zwpd04"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="责任人"
            align="center"
            prop="fzr"
            width="200px"
          >
            <template slot-scope="scope">
              <el-select
                :disabled="isDisabled"
                filterable
                v-model="scope.row.fzrIds"
                multiple
                @change="(data) => changeUser(data, scope.row)"
                @remove-tag="(data) => removetag(data, scope.row)"
                @visible-change="(data) => visibleChange(data, scope.row)"
                placeholder="责任人"
              >
                <el-option
                  :label="item.user04"
                  :title="item.user02"
                  :value="item.user01"
                  :key="item.user01"
                  v-for="item in scope.row.userList"
                  v-show="item.isSelect === false"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="审核人"
            align="center"
            prop="shr"
            width="200px"
          >
            <template slot-scope="scope">
              <el-select
                :disabled="isDisabled"
                filterable
                v-model="scope.row.shrIds"
                multiple
                @change="(data) => changeUser(data, scope.row)"
                @remove-tag="(data) => removetag(data, scope.row)"
                @visible-change="(data) => visibleChange(data, scope.row)"
                placeholder="审核人"
              >
                <el-option
                  :label="item.user04"
                  :title="item.user02"
                  :value="item.user01"
                  :key="item.user01"
                  v-for="item in scope.row.userList"
                  v-show="item.isSelect === false"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            property="planDays"
            label="计划工作时长"
            width="110px"
          >
          </el-table-column>
          <el-table-column
            property="trueDays"
            label="实际工作时长"
            width="110px"
          >
          </el-table-column>
          <el-table-column property="zwpd05" label="计划开始时间" width="215px">
            <template slot-scope="scope">
              <el-date-picker
                :disabled="isDisabled"
                type="datetime"
                placeholder="选择日期"
                v-model="scope.row.zwpd05"
                style="width: 100%"
                @change="changePlanStartDate(scope.row)"
              ></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column property="zwpd06" label="计划完成时间" width="215px">
            <template slot-scope="scope">
              <el-date-picker
                :disabled="isDisabled"
                type="datetime"
                placeholder="选择日期"
                v-model="scope.row.zwpd06"
                style="width: 100%"
                @change="changePlanStartDate(scope.row)"
              ></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column property="zwpd07" label="最迟完成时间" width="215px">
            <template slot-scope="scope">
              <el-date-picker
                :disabled="isDisabled"
                type="datetime"
                placeholder="选择日期"
                v-model="scope.row.zwpd07"
                style="width: 100%"
              ></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column property="zwpd08" label="审核结束时间" width="215px">
            <template slot-scope="scope">
              <el-date-picker
                :disabled="isDisabled"
                type="datetime"
                placeholder="选择日期"
                v-model="scope.row.zwpd08"
                style="width: 100%"
              ></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column property="zwpd09" label="实际开始时间" width="200px">
          </el-table-column>
          <el-table-column property="zwpd10" label="实际完成时间" width="200px">
          </el-table-column>
          <el-table-column property="zwpd11" label="备注" width="200px">
            <template slot-scope="scope">
              <el-input
                :disabled="isDisabled"
                v-model="scope.row.zwpd11"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.children.length === 0"
                type="primary"
                size="mini"
                @click="drawer2Open(scope.row)"
              >
                记录
              </el-button>
              <el-button
                type="warning"
                size="mini"
                @click="updateinfo(scope.row)"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 这里是甘特图 -->
        <gantt v-else :gantData="gantData"></gantt>
      </el-card>
    </div>
    <!-- 修改 -->
    <el-drawer
      style="overflow: auto"
      title="任务信息"
      :visible.sync="drawer"
      :before-close="handleClose"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="iteminfo" label-width="100px">
          <el-form-item label="任务名称">
            <el-input v-model="iteminfo.zwpd04" disabled></el-input>
          </el-form-item>
          <el-form-item label="负责人">
            <el-select
              multiple
              @change="changeUser2"
              v-model="iteminfo.fzList"
              @remove-tag="removetag2"
              style="width: 100%"
            >
              <el-option
                :label="item.user04"
                :title="item.user02"
                :value="item.user01"
                v-for="item in userList"
                :key="item.user01"
                v-show="item.isSelect === false"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核人">
            <el-select
              @change="changeUser2"
              multiple
              v-model="iteminfo.shList"
              @remove-tag="removetag2"
              style="width: 100%"
            >
              <el-option
                :label="item.user04"
                :title="item.user02"
                :value="item.user01"
                v-for="item in userList"
                :key="item.user01"
                v-show="item.isSelect === false"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务状态">
            <el-input v-model="iteminfo.state" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划开始时间">
            <el-date-picker
              type="datetime"
              placeholder="选择日期"
              v-model="iteminfo.zwpd05"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="计划结束时间">
            <el-date-picker
              type="datetime"
              placeholder="选择日期"
              v-model="iteminfo.zwpd06"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="最迟完成时间">
            <el-date-picker
              type="datetime"
              placeholder="选择日期"
              v-model="iteminfo.zwpd07"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="审核结束时间">
            <el-date-picker
              type="datetime"
              placeholder="选择日期"
              v-model="iteminfo.zwpd08"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="里程碑">
            <el-switch
              v-model="iteminfo.zwpd14"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-form-item>
          <el-form-item label="计划工作时长">
            <el-input v-model="iteminfo.planDays" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际开始时间">
            <el-input v-model="iteminfo.zwpd09" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际结束时间">
            <el-input v-model="iteminfo.zwpd10" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际工作时长">
            <el-input v-model="iteminfo.trueDays" disabled></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="iteminfo.zwpd11"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">修改</el-button>
            <el-button type="warning" @click="drawer = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-drawer>
    <!-- 插入节点 -->
    <el-dialog
      :close-on-click-modal="false"
      title="节点管理"
      :visible.sync="dialogVisibleDom"
      width="100%"
      top="0%"
    >
      <el-card
        class="box-card PlanInfo"
        style="maring-bottom: 30px; overflow: auto"
      >
        <el-button @click="addDom" type="primary">添加节点</el-button>
        <el-button @click="batchAddDom" type="primary">导入节点</el-button>
        <el-button @click="updateDom(1)" type="primary">更新</el-button>

        <el-row
          v-for="(item, index) in DomList"
          :key="index"
          :style="{ width: '1800px', marginLeft: `${item.tierNum * 30}px` }"
        >
          <el-col :span="2">
            名称
            <el-input v-model="item.zwpd04"></el-input>
          </el-col>
          <el-col :span="2">
            <el-select
              style="width: 100%"
              filterable
              v-model="item.fzList"
              @change="(data) => changeUser(data, item)"
              multiple
              @remove-tag="(data) => removetag(data, item)"
              @visible-change="(data) => visibleChange(data, item)"
              placeholder="负责人"
            >
              <el-option
                :label="item2.user04"
                :title="item2.user02"
                :value="item2.user01"
                v-for="item2 in item.userList"
                :key="item2.user01"
                v-show="item2.isSelect === false"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-select
              style="width: 100%"
              filterable
              v-model="item.shList"
              multiple
              @change="(data) => changeUser(data, item)"
              @remove-tag="(data) => removetag(data, item)"
              @visible-change="(data) => visibleChange(data, item)"
              placeholder="审核人"
            >
              <el-option
                :label="item2.user04"
                :title="item2.user02"
                :value="item2.user01"
                :key="item2.user01"
                v-for="item2 in item.userList"
                v-show="item2.isSelect === false"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="3"
            >里程碑
            <el-switch
              v-model="item.zwpd14"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              type="datetime"
              value-format="yyyy/MM/dd HH:mm:ss"
              v-model="item.zwpd05"
              placeholder="计划开始时间"
            ></el-date-picker>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              type="datetime"
              value-format="yyyy/MM/dd HH:mm:ss"
              v-model="item.zwpd06"
              placeholder="计划结束时间"
            ></el-date-picker>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              type="datetime"
              value-format="yyyy/MM/dd HH:mm:ss"
              v-model="item.zwpd07"
              placeholder="最迟完成时间"
            ></el-date-picker>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              type="datetime"
              value-format="yyyy/MM/dd HH:mm:ss"
              v-model="item.zwpd08"
              placeholder="审核结束时间"
            ></el-date-picker>
          </el-col>
          <el-col :span="1">
            <el-button
              type="danger"
              size="small"
              @click="deleteDom(index, item)"
              >删除</el-button
            >
          </el-col>
          <el-col :span="1">
            <el-button
              type="primary"
              size="small"
              @click="addChildDom(index, item)"
              >添加</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>
    <!-- 记录列表 -->
    <el-dialog
      :close-on-click-modal="false"
      title="记录列表"
      center
      :visible.sync="drawer2"
      width="40%"
    >
      <el-table :data="recordList" style="width: 100%">
        <el-table-column
          align="center"
          property="zwpr04"
          label="进度"
        ></el-table-column>
        <el-table-column align="center" property="zwpr05" label="提交说明">
        </el-table-column>
        <el-table-column
          align="center"
          property="zwpr06"
          label="创建时间"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 批量文件添加节点 -->
    <el-dialog
      :close-on-click-modal="false"
      title="xlsx导入"
      :visible.sync="batchAddFile"
      width="40%"
      center
    >
      <p>
        点击下载模板文件：
        <a
          style="color: red"
          :href="
            $store.state.baseUrl + '/UploadFiles/协同工作进度计划示例表格.xlsx'
          "
          target="_blank"
          >示例表格.XLSX</a
        >并按要求填好后上传
      </p>
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="actionUrl"
        :on-change="handleChange"
        :file-list="fileList"
        :limit="1"
        :data="nodeFileData"
        :before-upload="beforeUpload"
        accept=".xlsx"
        :auto-upload="false"
        :on-success="uploadSuccess"
        :headers="importHeaders"
        :on-exceed="handleExceed"
      >
        <el-button slot="trigger" size="small" type="primary"
          >选择文件</el-button
        >
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitUpload"
          >上传到服务器</el-button
        >
        <div slot="tip" class="el-upload__tip">仅能上传xlsx文件</div>
      </el-upload>
    </el-dialog>
    <!-- porject导入 -->
    <el-dialog
      :close-on-click-modal="false"
      title="porject导入"
      :visible.sync="batchProjectShow"
      width="40%"
      center
    >
      <p>
        点击下载模板文件：
        <a
          style="color: red"
          :href="
            $store.state.baseUrl + '/UploadFiles/协同工作进度计划示例工程.mpp'
          "
          target="_blank"
          >示例project.mmp</a
        >并按要求填好后上传
      </p>
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="actionUrl2"
        :on-change="handleChange"
        :file-list="fileList"
        :limit="1"
        :data="nodeFileData"
        :before-upload="beforeUpload"
        accept=".mpp"
        :auto-upload="false"
        :on-success="uploadSuccess"
        :headers="importHeaders"
        :on-exceed="handleExceed"
      >
        <el-button slot="trigger" size="small" type="primary"
          >选择文件</el-button
        >
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitUpload"
          >上传到服务器</el-button
        >
        <div slot="tip" class="el-upload__tip">仅能上传porject文件</div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import gantt from "@/components/gantt.vue";
import {
  GetZjwjPlanDetail,
  GetAuditUserList2,
  UpdateZjwjPlanNode,
  UpdateZjwjPlanNodeNew,
  GetZjwjOnePlanDetail,
  UpdateZjwjOnePlanDetail,
  GetZjwjPlanRecord,
  PlanStartAudit,
} from "@/setAxios";
export default {
  name: "constructionSchedule",
  components: { gantt },
  data() {
    return {
      // 编辑状态切换
      isDisabled: false,
      multipleSelection: [],
      nodeFileData: {
        gsid: localStorage.getItem("pid"),
        xid: localStorage.getItem("xid"),
        planid: "",
        uid: localStorage.getItem("id"),
      },
      importHeaders: { token: localStorage.getItem("token") },
      fileList: [],
      actionUrl: this.$store.state.baseUrl + "/api/insertZjwjExcelPlanNode",
      actionUrl2: this.$store.state.baseUrl + "/api/ExportMPP",
      gantData: {
        id: "",
      },
      ganttShow: true,
      loading: true,
      iteminfo: [],
      routerInfo: {
        zwpd05: null,
        zwpd06: null,
        zwpd07: null,
        zwpd08: null,
      },
      batchAddFile: false,
      batchProjectShow: false,
      DomList: [],
      drawer: false,
      drawer2: false,
      dialogVisibleDom: false, //节点管理卡片
      tableData: [],
      planid: "",
      modelId: "",
      zwpd01: "",
      time: [],
      addzwpd01: 1,
      tierNum: 0,
      isCreater: false,
      searchword: "",
      userList: [],
      fzList: [],
      shList: [],
      recordList: [],
      // 用来判断是否已经提交审核
      zwpp12: null,
      zwpp11: null,
      loadingMMp: null,
    };
  },
  created() {
    let params = {
      xid: localStorage.xid,
      qid: localStorage.pid,
      ids: "",
    };
    GetAuditUserList2(params).then((res) => {
      this.userList = res.Data;
      this.userList.forEach((ele) => {
        ele.isSelect = false;
      });
      try {
        let code = this.$route.query.code.replace(/%3D/g, "=");
        code = Base64.decode(code).split("&");
        this.planid = code[0].split("=")[1];
        this.zwpp12 = code[6].split("=")[1];
        this.zwpp11 = code[7].split("=")[1];
        if (this.zwpp11 == "null") {
          this.zwpp11 = null;
        }
        this.nodeFileData.planid = this.planid;
        this.initGantData(code);
        this.routerInfo.zwpd05 = new Date(Date.parse(code[1].split("=")[1]));
        this.routerInfo.zwpd06 = new Date(Date.parse(code[2].split("=")[1]));
        this.routerInfo.zwpd07 = new Date(Date.parse(code[3].split("=")[1]));
        this.routerInfo.zwpd08 = new Date(Date.parse(code[4].split("=")[1]));
        if (this.planid == "") {
          this.$message({
            type: "success",
            message: "请先选择进度计划",
          });
          this.$router.push({
            path: "/PlansToRelease",
          });
        } else {
          this.GetZjwjPlanDetail();
        }
      } catch {
        this.$message({
          type: "success",
          message: "请先选择进度计划",
        });
        this.$router.push({
          path: "/PlansToRelease",
        });
      }
    });
  },
  methods: {
    backRouter() {
      this.$router.push({
        path: "/PlansToRelease",
      });
    },
    async PlanStartAudit() {
      this.$confirm("是否提交审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          planid: this.planid,
        };
        let res = await PlanStartAudit(params);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "提成审核成功",
          });
        }
      });
    },
    changePlanStartDate(data) {
      if (data.zwpd06 && data.zwpd05) {
        let day = (new Date(data.zwpd06) - new Date(data.zwpd05)) / (24 * 60 * 60 * 1000);
        this.$set(data, "planDays", day);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 上传成功
    uploadSuccess(data) {
      this.loading2 = false;
      this.updataModel1 = false;
      this.loadingMMp.close();
      if (data.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.batchAddFile = false;
        this.batchProjectShow = false;
        this.dialogVisibleDom = false;
        this.GetZjwjPlanDetail();
      } else {
        this.$message({
          type: "warning",
          message: data.Message,
        });
      }
    },
    beforeUpload(file) {
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "xlsx" || suffix === "mpp";
      //(suffix);
      if (!extension) {
        this.$message({
          message: "上传文件只能是 xlsx,mmp格式!",
          type: "warning",
        });
        this.loading2 = false;
      }
      if (extension) {
        this.loadingMMp = this.$loading({
          lock: true,
          text: "数据上传中，请稍等...",
          spinner: "el-icon-loading",
          background: "rgba(0,0,0,0.5)",
        });
      }
      return extension;
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    initGantData(code) {
      this.gantData.id = code[0].split("=")[1];
    },
    async drawer2Open(data) {
      this.drawer2 = true;
      let params = {
        id: data.zwpd01,
      };
      let res = await GetZjwjPlanRecord({ params });
      this.recordList = res.Data;
    },
    async updateinfo(data) {
      let params = {
        id: data.zwpd01,
      };
      let res = await GetZjwjOnePlanDetail({ params });
      this.iteminfo = _.cloneDeep(res.Data);

      var newIds = [];
      this.iteminfo.fzList.forEach((ele) => {
        newIds.push(ele.user01);
      });
      this.iteminfo.fzList = newIds;
      var newIds = [];
      this.iteminfo.shList.forEach((ele) => {
        newIds.push(ele.user01);
      });
      this.iteminfo.shList = newIds;
      let newData = [...this.iteminfo.shList, ...this.iteminfo.fzList];
      newData.reduce((newObj, key) => {
        let findId = this.userList.findIndex((ele) => ele.user01 == key);
        this.$set(this.userList[findId], "isSelect", true);
      }, this.userList);
      this.drawer = true;
    },
    visibleChange(data, item) {},
    removetag(data, item) {
      // let findId = item.userList.findIndex((ele) => ele.user01 == data);
      // item.userList[findId].isSelect = false;
    },
    removetag2(data) {
      // let findId = this.userList.findIndex((ele) => ele.user01 == data);
      // this.userList[findId].isSelect = false;
    },
    changeUser(data, item) {
      // data.reduce((newobj, key) => {
      //   let findId = item.userList.findIndex((ele) => ele.user01 == key);
      //   item.userList[findId].isSelect = true;
      // }, item.userList);
    },

    changeUser2(data) {
      // data.reduce((newobj, key) => {
      //   let findId = this.userList.findIndex((ele) => ele.user01 == key);
      //   this.userList[findId].isSelect = true;
      // }, this.userList);
    },
    changeItemDate(time, item, type) {},
    addTierNum() {
      if (this.DomList.filter((e) => e.isUpdate == false).length > 0) {
        this.DomList.filter((e) => e.isUpdate == false).forEach((v, i) => {
          if (this.DomList[i].pid == 0) {
            this.DomList[i].tierNum = 0;
            this.DomList[i].isUpdate = true;
          } else {
            var a = this.DomList.filter(
              (ele) => ele.id == v.pid && ele.isUpdate
            );
            if (a.length > 0) {
              this.DomList[i].tierNum = a[0].tierNum + 1;
              this.DomList[i].isUpdate = true;
            }
          }
        });
      }
      if (this.DomList.filter((e) => e.isUpdate == false).length > 0) {
        this.addTierNum();
      }
    },
    // 对获取的值进行排序
    itemRank() {
      this.DomList.forEach((item, index) => {
        let newArr = this.DomList.filter((ele) => ele.pid == item.id);
        let newArrLength = newArr.length;
        newArr.forEach((ele) => {
          let newIndex = this.DomList.findIndex(
            (ele2) => ele2.zwpd01 == ele.zwpd01
          );
          this.DomList.splice(newIndex, 1);
        });
        this.DomList.splice(index + 1, 0, ...newArr);
      });
    },
    async GetZjwjPlanDetail() {
      this.loading = true;
      let params = {
        planid: this.planid,
        searchword: this.searchword,
      };
      let res = await GetZjwjPlanDetail({ params });
      // 这里做数据处理转换elementTree格式
      let AllData = _.cloneDeep(res.Data);
      var maxzwpd01 = 0;
      AllData.forEach((ele) => {
        maxzwpd01 = maxzwpd01 < ele.zwpd01 ? ele.zwpd01 : maxzwpd01;
        ele.fzId = ele.fzList.length > 0 ? ele.fzList[0].user01 : "";
        ele.shId = ele.shList.length > 0 ? ele.shList[0].user01 : "";
        ele.fzr = [];
        ele.fzrIds = [];
        ele.fzList.forEach((ele2) => {
          ele.fzr.push(ele2.user04);
          ele.fzrIds.push(ele2.user01);
        });
        ele.fzr = ele.fzr.join(",");
        ele.shr = [];
        ele.shrIds = [];
        ele.shList.forEach((ele2) => {
          ele.shr.push(ele2.user04);
          ele.shrIds.push(ele2.user01);
        });
        ele.shr = ele.shr.join(",");
        let data2 = _.cloneDeep(this.userList);
        ele.userList = data2;
        // let newData = [...ele.shList, ...ele.fzList];
        // newData.reduce((newObj, key) => {
        //   let findId = ele.userList.findIndex(
        //     (ele2) => ele2.user01 == key.user01
        //   );
        //   this.$set(ele.userList[findId], "isSelect", true);
        // }, ele.userList);
      });
      this.addPldt01 = maxzwpd01 + 1;
      // 为了防止子组建更改父组建的值
      let treeMapList = AllData.reduce((memo, current) => {
        memo[current["zwpd01"]] = current;
        return memo;
      }, {});
      let result = AllData.reduce((arr, current) => {
        let pid = current.zwpd15;
        let parent = treeMapList[pid];
        if (parent) {
          parent.children
            ? parent.children.push(current)
            : (parent.children = [current]);
        } else if (pid === 0) {
          arr.push(current);
        }
        return arr;
      }, []);

      this.tableData = result;
      // console.log(this.tableData);
      this.loading = false;
    },
    async onSubmit() {
      let isPass = true;
      let a = new Date(Date.parse(this.iteminfo.zwpd05));
      let b = new Date(Date.parse(this.iteminfo.zwpd06));
      let c = new Date(Date.parse(this.iteminfo.zwpd07));
      let d = new Date(Date.parse(this.iteminfo.zwpd08));
      a < b && a < c && a < d ? (isPass = true) : (isPass = false);
      b > a && b < c && b < d ? (isPass = true) : (isPass = false);
      c > d && c > b && c > a ? (isPass = true) : (isPass = false);
      d > a && d > b && d > c ? (isPass = true) : (isPass = false);
      if (isPass === false) {
        this.$message({
          type: "waring",
          message: "时间选择错误",
        });
        return false;
      }
      var newArr = [];
      this.iteminfo.shList.forEach((ele) => {
        newArr.push({
          user01: ele,
        });
      });
      this.iteminfo.shList = newArr;

      var newArr = [];
      this.iteminfo.fzList.forEach((ele) => {
        newArr.push({
          user01: ele,
        });
      });
      this.iteminfo.fzList = newArr;
      let res = await UpdateZjwjOnePlanDetail(this.iteminfo);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "修改成功",
        });
        this.drawer = false;
        this.GetZjwjPlanDetail();
      }
      // console.log("submit!");
    },

    fzUsers(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].shList = data[i].shrIds;
        data[i].fzList = data[i].fzrIds;
        data[i].zwpd18 = i + 1;
        if (data[i].children.length) {
          this.fzUsers(data[i].children);
        }
      }
    },

    // 跟新节点
    async updateDom(type) {
      this.loading = true;
      this.fzUsers(this.tableData);
      this.DomList = type == 1 ? this.DomList : this.tableData;
      let params = {
        list: this.DomList,
        planid: this.planid,
      };
      let that = this;
      var itemPass = true;
      for (let i = 0; i < this.DomList.length; i++) {
        var item = this.DomList[i];
        //先判断是否全部为空
        if (
          item.zwpd05 == null &&
          item.zwpd06 == null &&
          item.zwpd07 == null &&
          item.zwpd08 == null
        ) {
          //全为空则读取计划数据
          item.zwpd05 = that.routerInfo.zwpd05;
          item.zwpd06 = that.routerInfo.zwpd06;
          item.zwpd07 = that.routerInfo.zwpd07;
          item.zwpd08 = that.routerInfo.zwpd08;
        } else if (
          //判断填写不完整的
          item.zwpd05 == null ||
          item.zwpd06 == null ||
          item.zwpd07 == null ||
          item.zwpd08 == null
        ) {
          itemPass = false;
          break;
        } else {
          //时间判断
          item.zwpd05 = new Date(Date.parse(item.zwpd05));
          item.zwpd06 = new Date(Date.parse(item.zwpd06));
          item.zwpd07 = new Date(Date.parse(item.zwpd07));
          item.zwpd08 = new Date(Date.parse(item.zwpd08));
          if (
            !(
              that.routerInfo.zwpd05 <= item.zwpd05 &&
              item.zwpd05 <= item.zwpd06 &&
              item.zwpd06 <= that.routerInfo.zwpd06 &&
              item.zwpd06 <= item.zwpd07 &&
              item.zwpd07 <= that.routerInfo.zwpd07 &&
              item.zwpd07 <= item.zwpd08 &&
              item.zwpd08 <= that.routerInfo.zwpd08
            )
          ) {
            itemPass = false;
            break;
          }
        }
      }

      if (itemPass === false) {
        this.$message({
          type: "danger",
          message: "时间选择错误",
        });
        this.loading = false;
        return false;
      }
      if (type == 1) {
        let res = await UpdateZjwjPlanNode(params);

        this.loading = false;
        if (res.Code > 0) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.dialogVisibleDom = false;
          this.GetZjwjPlanDetail();
        }
      } else {
        let res = await UpdateZjwjPlanNodeNew(params);
        this.loading = false;
        if (res.Code > 0) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.dialogVisibleDom = false;
          this.GetZjwjPlanDetail();
        }
      }
    },
    dialogVisibleOPen() {
      this.dialogVisibleDom = true; //节点管理卡片开启
    },
    // 外层添加节点
    addDom2() {
      let data = _.cloneDeep(this.userList);
      this.tableData.push({
        userList: data,
        flrIds: [],
        shrIds: [],
        zwpd01: this.addPldt01,
        zwpd02: localStorage.xid,
        zwpd03: this.planid,
        zwpd04: "",
        zwpd05: null,
        zwpd06: null,
        zwpd07: null,
        zwpd08: null,
        zwpd09: "",
        zwpd10: "",
        zwpd11: "",
        zwpd12: localStorage.id,
        zwpd13: new Date(),
        zwpd14: true,
        // 父节点
        zwpd15: "",
        type: "new",
        children: [],
      });
      this.addPldt01++;
    },
    addDom() {
      let data = _.cloneDeep(this.userList);
      this.DomList.push({
        userList: data,
        flList: [],
        shList: [],
        tierNum: this.tierNum,
        id: this.addPldt01,
        zwpd01: 0,
        zwpd02: localStorage.xid,
        zwpd03: this.planid,
        zwpd04: "",
        zwpd05: null,
        zwpd06: null,
        zwpd07: null,
        zwpd08: null,
        zwpd09: "",
        zwpd10: "",
        zwpd11: "",
        zwpd12: localStorage.id,
        zwpd13: new Date(),
        zwpd14: true,
        // 父节点
        zwpd15: "",
        type: "new",
        isPClear: true,
        pid: 0,
      });
      this.addPldt01++;
    },
    // 添加子节点++++++++++++
    addChildDom(index, item) {
      this.DomList[index].isExpansionShow = true;
      this.getTierNum(item);
      let isPClear = false;
      if (item.type == "new") {
        isPClear = true;
      }
      let data = _.cloneDeep(this.userList);
      this.DomList.splice(index + 1, 0, {
        userList: data,
        flList: [],
        shList: [],
        tierNum: this.tierNum,
        id: this.addPldt01,
        zwpd01: 0,
        zwpd02: localStorage.xid,
        zwpd03: this.planid,
        zwpd04: "",
        zwpd05: null,
        zwpd06: null,
        zwpd07: null,
        zwpd08: null,
        zwpd09: "",
        zwpd10: "",
        zwpd11: "",
        zwpd12: localStorage.id,
        zwpd13: new Date(),
        zwpd14: true,
        // 父节点
        zwpd15: item.id,
        type: "new",
        isPClear: isPClear,
        pid: item.id,
      });
      this.addPldt01++;
      this.tierNum = 0;
      this.DomList = JSON.parse(JSON.stringify(this.DomList));
    },
    //外层添加子节点
    addChildDom2() {
      if (this.multipleSelection.length > 1) {
        this.$message({
          type: "warning",
          message: "只能往单个节点添加",
        });
        return;
      } else if (this.multipleSelection.length == 0) {
        this.addDom2();
        return;
      }
      this.initData(this.tableData);

      // this.$refs.multipleTable.clearSelection();
    },
    initData(data) {
      data.forEach((ele) => {
        if (ele.zwpd01 == this.multipleSelection[0].zwpd01) {
          let data2 = _.cloneDeep(this.userList);
          let option = {
            userList: data2,
            flrIds: [],
            shrIds: [],
            zwpd01: this.addPldt01,
            zwpd02: localStorage.xid,
            zwpd03: this.planid,
            zwpd04: "",
            zwpd05: null,
            zwpd06: null,
            zwpd07: null,
            zwpd08: null,
            zwpd09: "",
            zwpd10: "",
            zwpd11: "",
            zwpd12: localStorage.id,
            zwpd13: new Date(),
            zwpd14: true,
            // 父节点
            zwpd15: ele.zwpd01,
            type: "new",
            children: [],
          };
          ele.children.push(option);
          this.addPldt01++;
        } else if (ele.children.length > 0) {
          this.initData(ele.children);
        }
      });
    },
    // 判断是多少级
    getTierNum(item) {
      if (item.pid == 0) {
        this.tierNum++;
      } else {
        this.tierNum++;
        let newArr = this.DomList.find((ele) => ele.id == item.pid);
        if (newArr) {
          this.getTierNum(newArr);
        }
      }
    },
    // 删除节点{}-
    deleteDom(index, item) {
      let newObj = this.DomList.filter((ele) => ele.pid == item.id);
      if (newObj) {
        this.DomList.splice(index, 1);
        newObj.forEach((ele) => {
          let newIndex = this.DomList.findIndex((ele2) => ele2.id == ele.id);
          this.deleteDom(newIndex, ele);
        });
      } else {
        this.DomList.splice(index, 1);
      }
    },
    deleteDom2() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择需要删除节点",
        });
        return;
      }
      this.deletData(this.tableData);
      this.$refs.multipleTable.clearSelection();
    },
    deletData(data) {
      for (var i = 0; i < data.length; i++) {
        var ele = data[i];
        var list = this.multipleSelection.filter((w) => w.zwpd01 == ele.zwpd01);
        if (list.length) {
          data.splice(i, 1);
          i--;
        }
        if (ele.children.length > 0) {
          this.deletData(ele.children);
        }
      }
    },
    domUp() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择节点",
        });
        return;
      }
      this.upData(this.tableData);
      this.$refs.multipleTable.clearSelection();
    },
    upData(data) {
      for (var i = 0; i < data.length; i++) {
        var ele = data[i];
        if (ele.zwpd01 == this.multipleSelection[0].zwpd01) {
          if (i == 0) {
            this.$message({
              type: "warning",
              message: "已处于同级的最上级",
            });
            return;
          }
          let a = _.cloneDeep(data[i]);
          this.$set(data, i, _.cloneDeep(data[i - 1]));
          this.$set(data, i - 1, a);
          return;
        } else {
          if (ele.children.length > 0) {
            this.upData(ele.children);
          }
        }
      }
    },
    domDown() {
      // 只能同级升降
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择节点",
        });
        return;
      }
      this.downData(this.tableData);
      this.$refs.multipleTable.clearSelection();
    },
    downData(data) {
      for (var i = 0; i < data.length; i++) {
        var ele = data[i];
        if (ele.zwpd01 == this.multipleSelection[0].zwpd01) {
          if (i == data.length - 1) {
            this.$message({
              type: "warning",
              message: "已处于同级的最下级",
            });
            return;
          }
          let a = _.cloneDeep(data[i]);
          this.$set(data, i, _.cloneDeep(data[i + 1]));
          this.$set(data, i + 1, a);
          return;
        } else {
          if (ele.children.length > 0) {
            this.downData(ele.children);
          }
        }
      }
    },
    batchAddDom() {
      this.batchAddFile = true;
    },
    batchProject() {
      this.batchProjectShow = true;
    },
    // 关闭及修改
    handleClose(done) {
      this.$confirm("还有未保存的工作哦确定关闭吗？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-drawer__open .el-drawer.rtl {
  overflow: auto;
}
/deep/.el-drawer__open .el-drawer.ltr {
  overflow: auto;
}
#ProjectFileTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  line-height: 21px;
  margin-right: 2px;
}
div#dataListRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#dataListRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#dataListRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#dataListRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

.model {
  width: 45%;
  position: fixed;
  height: 50%;
  display: inline-flex;
}
.modelBottom {
  width: 45%;
  position: fixed;
  top: 70%;
  height: 20%;
  overflow-y: auto;
}
.constructionSchedule .search-input {
  width: 200px;
}
.constructionSchedule .el-table .warning-row {
  background: oldlace;
}

.constructionSchedule .el-table .success-row {
  background: #f0f9eb;
}
.PlanInfo {
  margin-bottom: 10px;
  font-size: 18px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  .el-form-item {
    margin-bottom: 5px;
  }
}
.el-drawer__open .el-drawer.rtl {
  overflow: auto;
}
.el-drawer__open .el-drawer.ltr {
  overflow: auto;
}
.constructionSchedule .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 85%;
}
.constructionSchedule .PlanInfo .el-input {
  width: 70%;
}
[data-v-e741f4b6] .el-dialog__body {
  padding-bottom: 20px;
}
.gantt_ot {
  width: 100% !important;
  margin: 0px !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
.el-table__body tr.current-row > td {
  background-color: oldlace !important;
}

.PlanInfo {
  margin-bottom: 10px;
  font-size: 18px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  .el-form-item {
    margin-bottom: 5px;
  }
}
.el-card__body {
  overflow: auto;
  width: 100%;
}
</style>
